import { _ as e, a as o, L as t, P as r, g as a, M as i, b as c } from "./index.browser-8ac214e0.js";
import s from "react";
import { render as n, hydrate as g } from "react-dom";
import "common-tags";
import "camelcase";
var m = ["image", "loading", "isLoading", "isLoaded", "toggleIsLoaded", "ref", "imgClassName", "imgStyle", "objectPosition", "backgroundColor", "objectFit"];

function d(d, l, u, b) {
  var p = d.image,
      h = d.loading,
      j = d.isLoading,
      f = d.isLoaded,
      L = d.toggleIsLoaded,
      v = d.ref,
      y = d.imgClassName,
      C = d.imgStyle,
      k = void 0 === C ? {} : C,
      w = d.objectPosition,
      N = d.backgroundColor,
      P = d.objectFit,
      E = void 0 === P ? "cover" : P,
      F = e(d, m),
      O = p.width,
      S = p.height,
      x = p.layout,
      I = p.images,
      J = p.placeholder,
      M = p.backgroundColor,
      _ = JSON.stringify(I);

  k = o({
    objectFit: E,
    objectPosition: w,
    backgroundColor: N
  }, k);
  var q = s.createElement(t, {
    layout: x,
    width: O,
    height: S
  }, s.createElement(r, Object.assign({}, a(J, f, x, O, S, M, E, w))), s.createElement(i, Object.assign({}, F, {
    width: O,
    height: S,
    className: y
  }, c(j, f, I, h, L, _, v, k))));
  return l.current && ((u.current || b.current ? n : g)(q, l.current), u.current = !0), function () {
    l.current && n(null, l.current);
  };
}

export { d as lazyHydrate };